import { useEnvironment, useExperiments, useTranslation } from '@wix/yoshi-flow-editor';
import React, { FC } from 'react';
import { Text, TextPriority } from 'wix-ui-tpa/cssVars';
import { SHOW_DISCOUNT_EXPERIMENT } from '../../../constants';
import { classes, st } from './DiscountName.st.css';

type DiscountNameProps = {
  discountName: string | undefined;
  showCalculatedAtCheckout: boolean;
};

export const DiscountName: FC<DiscountNameProps> = ({
  discountName,
  showCalculatedAtCheckout,
}) => {
  const { isMobile } = useEnvironment();
  const { experiments } = useExperiments();
  const { t } = useTranslation();
  const isDiscountEnabled = experiments.enabled(SHOW_DISCOUNT_EXPERIMENT);

  if (!isDiscountEnabled || !discountName) {
    return null;
  }

  return (
    <div data-hook="details-discount-name" className={st(classes.root, { isMobile })}>
      <Text className={classes.discountName}>{discountName}</Text>
      {showCalculatedAtCheckout && (
        <Text data-hook="details-calculated-at-checkout" className={classes.calculatedAtCheckout} priority={TextPriority.secondary}>
          {t('service-details.calculated-at-checkout')}
        </Text>
      )}
    </div>
  );
};
